export default __webpack_public_path__ + "static/media/lesarcs-2x.d607f350.webp";